import React from 'react';
import DashboardIcon from '@mui/icons-material/Dashboard';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import SettingsIcon from '@mui/icons-material/Settings';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import ChatIcon from '@mui/icons-material/Chat';
import GroupsIcon from '@mui/icons-material/Groups';
import PeopleIcon from '@mui/icons-material/People';
import AssignmentIcon from '@mui/icons-material/Assignment';
// Additional specific icons for better visual identification
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import ArticleIcon from '@mui/icons-material/Article';
import QuizIcon from '@mui/icons-material/Quiz';
import CreateIcon from '@mui/icons-material/Create';
import GradingIcon from '@mui/icons-material/Grading';
import CalculateIcon from '@mui/icons-material/Calculate';
import FunctionsIcon from '@mui/icons-material/Functions';

interface SubMenuItem {
  text: string;
  path: string;
  icon?: React.ReactNode; // Add icon support for sub-menu items
  requiresSubject?: 'Math' | 'Reading' | 'ELA'; // Subject requirement for conditional display
  devOnly?: boolean; // If true, only shows in development environment
}

interface MenuItem {
  text: string;
  icon: React.ReactNode;
  path?: string;
  items?: SubMenuItem[];
  section?: string;
  requiresSubject?: 'Math' | 'Reading' | 'ELA'; // Subject requirement for conditional display
}

export const menuItems: MenuItem[] = [
  {
    section: 'Main',
    text: 'Home',
    icon: <DashboardIcon />,
    path: '/dashboard'
  },
  {
    text: 'Teaching Chat',
    icon: <ChatIcon />,
    path: '/edu-chat'
  },
  // DO NOT REMOVE UNTIL REQUESTED - Guided Reading section
  /*{
    text: 'Guided Reading',
    icon: <MenuBookIcon />,
    path: '/guided-reading'
  },*/
  {
    section: 'Teaching',
    text: 'Small Group',
    icon: <GroupsIcon />,
    items: [
      { 
        text: 'Lesson Plan', 
        path: '/small-group/lesson-plan',
        icon: <AutoAwesomeIcon />
      },
      { 
        text: 'Saved Lesson Plans', 
        path: '/small-group/saved',
        icon: <BookmarkIcon />
      },
      { 
        text: 'Lesson Delivery', 
        path: '/small-group/delivery',
        icon: <PlayArrowIcon />
      }
    ]
  },
  {
    text: 'Roster',
    icon: <PeopleIcon />,
    items: [
      { 
        text: 'Students', 
        path: '/add-students',
        icon: <PersonAddIcon />
      },
      { 
        text: 'Groups', 
        path: '/add-group',
        icon: <GroupsIcon />
      }
    ]
  },
  {
    section: 'Resources',
    text: 'Resources and Assessments',
    icon: <LibraryBooksIcon />,
    items: [
      { 
        text: 'Create Passage(s)', 
        path: '/assessments',
        icon: <AssignmentIcon />,
        requiresSubject: 'Reading'
      },
      {
        text: 'Math Word Problems',
        path: '/math-word-problems',
        icon: <CalculateIcon />,
        requiresSubject: 'Math'
      },
      {
        text: 'Passage List',
        path: '/passage-list',
        icon: <ArticleIcon />
      },
      {
        text: 'Math Problems List',
        path: '/math-word-problems-list',
        icon: <FunctionsIcon />,
        requiresSubject: 'Math'
      },
      { 
        text: 'Create Test', 
        path: '/tests/create',
        icon: <CreateIcon />
      },
      { 
        text: 'Tests', 
        path: '/tests',
        icon: <QuizIcon />
      },
      { 
        text: 'Grade Tests', 
        path: '/tests/grade',
        icon: <GradingIcon />
      }
    ]
  },
  {
    text: 'Assessments',
    icon: <QuizIcon />,
    path: '/dashboard/assessments'
  },
  {
    section: 'System',
    text: 'Settings',
    icon: <SettingsIcon />,
    path: '/settings'
  }
];

export default menuItems; 